import { AdvancedTooltip } from '@23degrees/shared-code/models';

export const DEFAULT_TOOLTIP: AdvancedTooltip = {
  enabled: true,
  content: '',
  event: 'click',
  type: 'classic',
  position: 'global',
  style: {
    font: {
      enabled: true,
      position: 'left',
      size: 12,
      weight: '300',
      color: '#000000',
      fontFamily: "'Work Sans', sans-serif",
      letterSpacing: 0,
      shadow: {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: 'transparent'
      },
      lineheight: { value: 'initial', unit: 'em' },
      margin: {
        top: 0,
        right: 0,
        topUnit: 'px',
        bottom: 0,
        left: 0,
        rightUnit: 'px',
        bottomUnit: 'px',
        leftUnit: 'px'
      },
      padding: {
        top: 10,
        right: 10,
        topUnit: 'px',
        bottom: 10,
        left: 10,
        rightUnit: 'px',
        bottomUnit: 'px',
        leftUnit: 'px'
      }
    },
    background: {
      backgroundColor: '#fff'
    },
    boxShadow: {
      x: 0,
      y: 2,
      blur: 10,
      spread: 0,
      color: 'rgba(0,0,0,0.4)'
    },
    closeButton: {
      icon: 'cancel-1',
      iconPosition: 'left',
      text: null,
      borderRadius: 100,
      font: {
        enabled: true,
        position: 'left',
        size: 12,
        weight: '300',
        color: '#fff',
        fontFamily: "'Work Sans', sans-serif",
        letterSpacing: 0,
        shadow: {
          x: 0,
          y: 0,
          blur: 0,
          spread: 0,
          color: 'transparent'
        },
        lineheight: {
          value: 1.2,
          unit: 'em'
        },
        margin: {
          top: 5,
          right: 5,
          topUnit: 'px',
          bottom: 5,
          left: 5,
          rightUnit: 'px',
          bottomUnit: 'px',
          leftUnit: 'px'
        },
        padding: {
          top: 5,
          right: 5,
          topUnit: 'px',
          bottom: 5,
          left: 5,
          rightUnit: 'px',
          bottomUnit: 'px',
          leftUnit: 'px'
        }
      },
      background: {
        backgroundColor: '#000'
      },
      boxShadow: {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: 'transparent'
      },
      hoverStyle: {
        icon: 'cancel-1',
        iconPosition: 'left',
        text: null,
        borderRadius: 100,
        font: {
          enabled: true,
          position: 'left',
          size: 12,
          weight: '300',
          color: '#000',
          fontFamily: "'Work Sans', sans-serif",
          letterSpacing: 0,
          shadow: {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0,
            color: 'transparent'
          },
          lineheight: {
            value: 1.2,
            unit: 'em'
          },
          margin: {
            top: 5,
            right: 5,
            topUnit: 'px',
            bottom: 5,
            left: 5,
            rightUnit: 'px',
            bottomUnit: 'px',
            leftUnit: 'px'
          },
          padding: {
            top: 5,
            right: 5,
            topUnit: 'px',
            bottom: 5,
            left: 5,
            rightUnit: 'px',
            bottomUnit: 'px',
            leftUnit: 'px'
          }
        },
        background: {
          backgroundColor: '#fff'
        },
        boxShadow: {
          x: 0,
          y: 2,
          blur: 4,
          spread: 0,
          color: 'rgba(0,0,0,0.4)'
        }
      },
      position: {
        vertical: 'top',
        horizontal: 'right'
      },
      size: {
        mobile: {
          unit: '%',
          value: 5
        },
        desktop: {
          unit: '%',
          value: 5
        }
      }
    },
    animation: 'move',
    scrollable: true,
    classic: {
      theme: 'default',
      maxWidth: {
        mobile: {
          unit: '%',
          value: 93
        },
        desktop: {
          unit: '%',
          value: 50
        }
      },
      maxHeight: {
        mobile: {
          unit: '%',
          value: 50
        },
        desktop: {
          unit: '%',
          value: 50
        }
      }
    },
    fullscreen: {
      background: {
        backgroundColor: '#fff'
      },
      width: {
        mobile: {
          unit: '%',
          value: 100
        },
        desktop: {
          unit: '%',
          value: 100
        }
      },
      height: {
        mobile: {
          unit: '%',
          value: 100
        },
        desktop: {
          unit: '%',
          value: 100
        }
      },
      content: {
        width: {
          mobile: {
            unit: '%',
            value: 100
          },
          desktop: {
            unit: '%',
            value: 100
          }
        },
        height: {
          mobile: {
            unit: '%',
            value: 100
          },
          desktop: {
            unit: '%',
            value: 100
          }
        }
      }
    },
    sidebar: {
      position: 'left',
      overlayType: 'overlay',
      width: {
        mobile: {
          unit: '%',
          value: 100
        },
        desktop: {
          unit: 'px',
          value: 300
        }
      }
    }
  }
};
